// configurador-app.js — JSX precompilado a JS plano (sin Babel en runtime).
// Generado a partir de: tweaks-panel.jsx, custom-logos.jsx, logos.jsx, cover-v2.jsx, app.jsx.
// NO editar a mano: edita los .jsx del proyecto y recompila.


/* ===================== tweaks-panel.jsx ===================== */
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({
  title = 'Tweaks',
  noDeckControls = false,
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  // Auto-inject a rail toggle when a <deck-stage> is on the page. The
  // toggle drives the deck's per-viewer _railVisible via window message;
  // state is mirrored from the same localStorage key the deck reads so
  // the control reflects reality across reloads. The mechanism is the
  // message — authors who want custom placement can post it directly
  // and pass noDeckControls to suppress this one.
  const hasDeckStage = React.useMemo(() => typeof document !== 'undefined' && !!document.querySelector('deck-stage'), []);
  // deck-stage enables its rail in connectedCallback, but this panel can
  // mount before that element has upgraded. The initial read catches the
  // common case; the listener covers mounting first. (Older deck-stage.js
  // copies still wait for the host's __omelette_rail_enabled postMessage —
  // same listener handles those.)
  const [railEnabled, setRailEnabled] = React.useState(() => hasDeckStage && !!document.querySelector('deck-stage')?._railEnabled);
  React.useEffect(() => {
    if (!hasDeckStage || railEnabled) return undefined;
    const onMsg = e => {
      if (e.data && e.data.type === '__omelette_rail_enabled') setRailEnabled(true);
    };
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, [hasDeckStage, railEnabled]);
  const [railVisible, setRailVisible] = React.useState(() => {
    try {
      return localStorage.getItem('deck-stage.railVisible') !== '0';
    } catch (e) {
      return true;
    }
  });
  const toggleRail = on => {
    setRailVisible(on);
    window.postMessage({
      type: '__deck_rail_visible',
      on
    }, '*');
  };
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, __TWEAKS_STYLE), /*#__PURE__*/React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-noncommentable": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "twk-body"
  }, children, hasDeckStage && railEnabled && !noDeckControls && /*#__PURE__*/React.createElement(TweakSection, {
    label: "Deck"
  }, /*#__PURE__*/React.createElement(TweakToggle, {
    label: "Thumbnail rail",
    value: railVisible,
    onChange: toggleRail
  })))));
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label), value != null && /*#__PURE__*/React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-row twk-row-h"
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, /*#__PURE__*/React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return /*#__PURE__*/React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-num"
  }, /*#__PURE__*/React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && /*#__PURE__*/React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "twk-row twk-row-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "twk-lbl"
    }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && /*#__PURE__*/React.createElement("span", null, sup.map((c, j) => /*#__PURE__*/React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && /*#__PURE__*/React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});

/* ===================== custom-logos.jsx ===================== */
// Logos personalizados con su propio offset/contorno.
// Cargados desde window.LOGO_DATA (generado a partir de los SVG en uploads/).
//
// Cada SVG fuente tiene dos capas:
//   • g#offset → contorno / detalles  (se pinta con `offsetColor`)
//   • g#Logo   → relleno / letras     (se pinta con `color`)
//
// Convención del render: ({ color, offsetColor, size }) → coloca el logo
// centrado en (0,0) y con anchura ≈ `size`.

// Catálogo: id corto, label legible y archivo origen.
const CUSTOM_LOGO_LIST = [{
  id: '2fast',
  label: '2FAST',
  key: '2fast-4a9d8b26'
}, {
  id: '2win',
  label: '2WIN',
  key: '2win'
}, {
  id: 'airsal',
  label: 'Airsal',
  key: 'Airsal'
}, {
  id: 'allpro',
  label: 'Allpro',
  key: 'Allpro'
}, {
  id: 'bandoboys',
  label: 'Bando Boys',
  key: 'Bando-boys'
}, {
  id: 'beta',
  label: 'Beta',
  key: 'Beta'
}, {
  id: 'bikelife',
  label: 'Bikelife',
  key: 'Bikelife'
}, {
  id: 'castrol',
  label: 'Castrol',
  key: 'Casstrol'
}, {
  id: 'corona',
  label: 'Corona',
  key: 'Corona'
}, {
  id: 'corona2',
  label: 'Corona II',
  key: 'Corona-2'
}, {
  id: 'diamante',
  label: 'Diamante',
  key: 'Diamante'
}, {
  id: 'estrellesS6',
  label: 'Estrellas S6',
  key: 'Estrelles_stage_6'
}, {
  id: 'gorilla',
  label: 'Gorilla',
  key: '4_rgb_gorilla__1_'
}, {
  id: 'krm',
  label: 'KRM',
  key: 'Krm'
}, {
  id: 'malossi',
  label: 'Malossi',
  key: 'Malossi'
}, {
  id: 'mostllarg',
  label: 'Most llarg',
  key: 'Most_llarg'
}, {
  id: 'motul',
  label: 'Motul',
  key: 'Motul'
}, {
  id: 'mrt',
  label: 'MRT',
  key: 'Mrt'
}, {
  id: 'redbull',
  label: 'Redbull',
  key: 'Redbull'
}, {
  id: 'redbulltoros',
  label: 'Redbull toros',
  key: 'Redbull_toros'
}, {
  id: 'rieju',
  label: 'Rieju',
  key: 'Rieju'
}, {
  id: 'riejusmx',
  label: 'Rieju SMX',
  key: 'Rieju-smx'
}, {
  id: 'scootfast',
  label: 'Scootfast',
  key: 'Scootfast'
}, {
  id: 'scootfastFull',
  label: 'Scootfast full',
  key: 'Scootfast_completo'
}, {
  id: 'scootfastLet',
  label: 'Scootfast letras',
  key: 'Scootfast_letras'
}, {
  id: 'sherco',
  label: 'Sherco',
  key: 'Sherco'
}, {
  id: 'sop',
  label: 'SOP',
  key: 'Sop'
}, {
  id: 'stage6',
  label: 'Stage 6',
  key: 'Stage_6'
}, {
  id: 'tiburon',
  label: 'Tiburón',
  key: 'Tiburon'
}, {
  id: 'tpr',
  label: 'TPR',
  key: 'Tpr'
}, {
  id: 'vespa',
  label: 'Vespa',
  key: 'Vespa'
}, {
  id: 'voca',
  label: 'Voca',
  key: 'Voca'
}, {
  id: 'yasuni',
  label: 'Yasuni',
  key: 'Yasuni'
}];

// Factory: crea un componente React para un logo dado.
//
// El SVG original mide 1920×1080 y trae un `transform` interno (translate+scale)
// que mapea las coords del path al viewBox. Calculamos la bbox real del logo
// dentro de ese viewBox, la trasladamos al origen y escalamos para que el ancho
// final sea `size`. Devolvemos { color, offsetColor } como rellenos de las dos capas.
function makeCustomLogo(entry) {
  const data = window.LOGO_DATA[entry.key];
  if (!data) return null;
  const [bx, by, bw, bh] = data.bb;
  const aspect = bh / bw;
  const Comp = ({
    color,
    offsetColor,
    size = 120
  }) => {
    const scale = size / bw;
    // Trasladamos para que el centro de la bbox quede en (0,0) tras escalar.
    const tx = -((bx + bw / 2) * scale);
    const ty = -((by + bh / 2) * scale);
    return /*#__PURE__*/React.createElement("g", {
      transform: `translate(${tx}, ${ty}) scale(${scale})`
    }, /*#__PURE__*/React.createElement("g", {
      transform: data.it
    }, /*#__PURE__*/React.createElement("path", {
      d: data.off,
      fill: offsetColor
    }), data.lo ? /*#__PURE__*/React.createElement("path", {
      d: data.lo,
      fill: color
    }) : null));
  };
  return {
    component: Comp,
    aspect,
    naturalBox: {
      w: 100,
      h: 100 * aspect
    }
  };
}

// Registramos todos los logos personalizados en window.CUSTOM_LOGOS.
window.CUSTOM_LOGOS = {};
window.CUSTOM_LOGO_LIST = CUSTOM_LOGO_LIST;
for (const entry of CUSTOM_LOGO_LIST) {
  const made = makeCustomLogo(entry);
  if (made) {
    window.CUSTOM_LOGOS[entry.id] = {
      ...made,
      id: entry.id,
      label: entry.label
    };
  } else {
    console.warn('[custom-logos] No data for', entry.key);
  }
}

/* ===================== logos.jsx ===================== */
// Catálogo de logos para las tres zonas (superior / central / inferior).
//
// Los logos se cargan desde window.CUSTOM_LOGOS (ver custom-logos.jsx),
// que a su vez lee los SVG originales subidos por el usuario en uploads/*.svg.
// Cada logo trae sus dos capas (offset = detalles, Logo = letras), así que
// todos los del catálogo declaran `hasCustomOffset: true`.

const LogoNinguno = () => null;

// Construimos el catálogo a partir de CUSTOM_LOGO_LIST para preservar el orden
// en que se ven los logos en el dropdown.
const CUSTOM_ENTRIES = (window.CUSTOM_LOGO_LIST || []).map(entry => {
  const c = window.CUSTOM_LOGOS[entry.id];
  if (!c) return null;
  return {
    id: entry.id,
    label: entry.label,
    render: c.component,
    hasCustomOffset: true,
    naturalBox: c.naturalBox
  };
}).filter(Boolean);
const LOGO_CATALOG = [{
  id: 'none',
  label: 'Ninguno',
  render: LogoNinguno
}, ...CUSTOM_ENTRIES];
window.LOGO_CATALOG = LOGO_CATALOG;

// Tamaño de render por zona ya no es necesario (lo gestiona fitLogoToSlot).
// Lo dejamos como tabla vacía por compatibilidad si alguien lo consulta.
window.LOGO_RENDER_SIZES = {
  top: {},
  center: {},
  bottom: {}
};

// Encaja un logo dentro de un slot rectangular usando política "contain":
// escala el logo para que quepa dentro manteniendo aspecto.
// Devuelve { entry, size, scale, naturalBox } o null si el logo es 'none'.
window.fitLogoToSlot = function fitLogoToSlot(logoId, slot) {
  const entry = LOGO_CATALOG.find(l => l.id === logoId);
  if (!entry || entry.id === 'none') return null;
  const nat = entry.naturalBox || {
    w: 100,
    h: 100
  };
  // Margen de seguridad: el logo nunca toca el borde de su zona (88% del hueco).
  const margin = slot.margin != null ? slot.margin : 0.88;
  const scale = Math.min(slot.w * margin / nat.w, slot.h * margin / nat.h);
  return {
    entry,
    scale,
    size: 100 * scale,
    naturalBox: nat
  };
};

/* ===================== cover-v2.jsx ===================== */
// Componente Cover V2 — usa el SVG preprocesado de product-v2.js
// Renderiza el contorno con colores dinámicos vía CSS vars + textos + logos en slots.
//
// Si NO se pasa `renderLogoInSlot`, usamos un renderer por defecto que encaja cada
// logo del catálogo (window.LOGO_CATALOG + window.fitLogoToSlot) en su slot con
// política "contain", aplicando halo automático en color detalles.

const V2Cover = ({
  base,
  details,
  letters,
  logoTop,
  logoCenter,
  logoBottom,
  instagram,
  instagramFont,
  instagramScale = 1,
  finish = 'matte',
  metacryl = false,
  renderLogoInSlot,
  product
}) => {
  const p = product || window.PRODUCT_V2;
  if (!p) return null;
  const styleVars = {
    '--c-base': base || '#0E0E10',
    '--c-details': details || '#E0282E',
    '--c-letters': letters || '#F5F4F0'
  };

  // Renderer por defecto: encaja el logo en su slot con "contain".
  const defaultRenderLogoInSlot = (logoId, slot, key) => {
    const fit = window.fitLogoToSlot && window.fitLogoToSlot(logoId, slot);
    if (!fit) return null;
    const cx = slot.x + slot.w / 2;
    const cy = slot.y + slot.h / 2;
    const Render = fit.entry.render;
    const hasOffset = fit.entry.hasCustomOffset;
    return /*#__PURE__*/React.createElement("g", {
      key: key,
      transform: `translate(${cx}, ${cy})`,
      filter: hasOffset ? undefined : 'url(#v2-logo-halo)'
    }, /*#__PURE__*/React.createElement(Render, {
      color: "var(--c-letters)",
      offsetColor: "var(--c-details)",
      size: fit.size
    }));
  };
  const rfn = renderLogoInSlot || defaultRenderLogoInSlot;

  // Renderizar texto dentro de una caja: encaja al ancho usando textLength.
  // Devuelve <text> centrado en el slot.
  const renderTextInBox = (text, slot, fontFamily, weight = 600, fitWidth = true) => {
    if (!text || !text.trim()) return null;
    const props = {
      x: slot.x + slot.w / 2,
      y: slot.y + slot.h / 2,
      textAnchor: 'middle',
      dominantBaseline: 'central',
      fill: 'var(--c-letters)',
      style: {
        fontFamily,
        fontWeight: weight,
        fontSize: slot.h * 0.85,
        letterSpacing: '0.005em'
      }
    };
    if (fitWidth) {
      props.textLength = slot.w;
      props.lengthAdjust = 'spacingAndGlyphs';
    }
    return /*#__PURE__*/React.createElement("text", props, text);
  };

  // Renderizar @instagram a lo largo de una curva (textPath).
  // slot: { pathD, fontSize, letterSpacing, maxTextLength }
  // - Se centra en el medio de la curva (startOffset="50%").
  // - Si el texto estimado supera `maxTextLength`, se autoencaja con textLength
  //   para que NUNCA se salga de la zona dibujada por el usuario.
  // Id único por instancia para el path de textPath (evita colisiones si hay varios covers).
  // React.useId() devuelve ':r0:' u similar — quitamos ':' porque no es válido en URL fragments.
  const uid = React.useId().replace(/:/g, '');
  const instaPathId = `v2-insta-${uid}`;
  const clipId = `v2-cover-clip-${uid}`;
  const renderInstagramText = (text, slot, fontFamily, weight = 600, scale = 1) => {
    if (!text || !text.trim()) return null;
    const fontSize = (slot.fontSize || 22) * scale;
    // Estimación de ancho: ~0.58 * fontSize por carácter para Space Grotesk medium.
    const estWidth = text.length * fontSize * 0.58;
    const max = (slot.maxTextLength || 290) * scale;
    const useTextLength = estWidth > max;
    return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
      id: instaPathId,
      d: slot.pathD,
      fill: "none"
    })), /*#__PURE__*/React.createElement("text", {
      fill: "var(--c-letters)",
      textLength: useTextLength ? max : undefined,
      lengthAdjust: useTextLength ? 'spacingAndGlyphs' : undefined,
      style: {
        fontFamily,
        fontWeight: weight,
        fontSize,
        letterSpacing: slot.letterSpacing || '0.01em'
      }
    }, /*#__PURE__*/React.createElement("textPath", {
      href: `#${instaPathId}`,
      startOffset: "50%",
      textAnchor: "middle"
    }, text)));
  };

  // ============================================================
  // RENDER GENÉRICO para diseños con `rawSvg` (SVG por capas con
  // colores marcadores ya sustituidos por var(--c-base/details/letters)).
  // Coloca logos en los slots (respetando su transform) y, si existe,
  // el texto de Instagram sobre su curva.
  // ============================================================
  if (p.rawSvg) {
    const renderLogoRaw = (logoId, slot, key) => {
      if (!logoId || logoId === 'none' || !slot) return null;
      const fit = window.fitLogoToSlot && window.fitLogoToSlot(logoId, slot);
      if (!fit) return null;
      const cx = slot.x + slot.w / 2;
      const cy = slot.y + slot.h / 2;
      const Render = fit.entry.render;
      const hasOffset = fit.entry.hasCustomOffset;
      return /*#__PURE__*/React.createElement("g", {
        key: key,
        transform: slot.transform || undefined
      }, /*#__PURE__*/React.createElement("g", {
        transform: `translate(${cx}, ${cy})`,
        filter: hasOffset ? undefined : 'url(#v2-logo-halo)'
      }, /*#__PURE__*/React.createElement(Render, {
        color: "var(--c-letters)",
        offsetColor: "var(--c-details)",
        size: fit.size
      })));
    };
    const s = p.slots || {};
    return /*#__PURE__*/React.createElement("svg", {
      viewBox: p.viewBox,
      style: {
        width: '100%',
        height: '100%',
        display: 'block',
        ...styleVars
      },
      "aria-label": p.label || 'Tapa personalizable'
    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
      id: "v2-shadow",
      x: "-20%",
      y: "-20%",
      width: "140%",
      height: "140%"
    }, /*#__PURE__*/React.createElement("feGaussianBlur", {
      in: "SourceAlpha",
      stdDeviation: "14"
    }), /*#__PURE__*/React.createElement("feOffset", {
      dx: "0",
      dy: "18",
      result: "o"
    }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
      type: "linear",
      slope: "0.28"
    })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
      in: "SourceGraphic"
    }))), /*#__PURE__*/React.createElement("filter", {
      id: "v2-logo-halo",
      x: "-30%",
      y: "-30%",
      width: "160%",
      height: "160%"
    }, /*#__PURE__*/React.createElement("feMorphology", {
      in: "SourceAlpha",
      operator: "dilate",
      radius: "3",
      result: "m"
    }), /*#__PURE__*/React.createElement("feFlood", {
      floodColor: "var(--c-details)",
      result: "c"
    }), /*#__PURE__*/React.createElement("feComposite", {
      in: "c",
      in2: "m",
      operator: "in",
      result: "halo"
    }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
      in: "halo"
    }), /*#__PURE__*/React.createElement("feMergeNode", {
      in: "SourceGraphic"
    })))), /*#__PURE__*/React.createElement("g", {
      filter: "url(#v2-shadow)"
    }, /*#__PURE__*/React.createElement("g", {
      dangerouslySetInnerHTML: {
        __html: p.rawSvg
      }
    }), renderLogoRaw(logoTop, s.top, 'lt'), renderLogoRaw(logoCenter, s.center, 'lc'), renderLogoRaw(logoBottom, s.bottom, 'lb'), p.instagramSlot && renderInstagramText(instagram && instagram.trim() ? `@${instagram.replace(/^@/, '')}` : '', p.instagramSlot, instagramFont, 600, instagramScale)));
  }
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: p.viewBox,
    style: {
      width: '100%',
      height: '100%',
      display: 'block',
      ...styleVars
    },
    "aria-label": "Tapa V2 personalizable"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "v2-shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: "14"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: "0",
    dy: "18",
    result: "o"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: "0.28"
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "v2-logo-halo",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: "3",
    result: "m"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "var(--c-details)",
    result: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "c",
    in2: "m",
    operator: "in",
    result: "halo"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "halo"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), p.clipShapes && /*#__PURE__*/React.createElement("clipPath", {
    id: clipId
  }, p.clipShapes.map((s, i) => /*#__PURE__*/React.createElement("path", {
    key: i,
    d: s.d,
    transform: s.transform || undefined
  }))), /*#__PURE__*/React.createElement("pattern", {
    id: "v2-galaxy-pattern",
    x: "0",
    y: "0",
    width: "60",
    height: "60",
    patternUnits: "userSpaceOnUse"
  }, [[5, 8, 0.9], [22, 14, 1.2], [38, 6, 0.8], [50, 18, 1.0], [10, 30, 1.1], [28, 36, 0.7], [44, 28, 1.3], [56, 42, 0.9], [16, 50, 0.8], [34, 54, 1.0], [48, 50, 0.7], [6, 44, 1.1], [20, 22, 0.6], [42, 44, 0.6], [30, 12, 0.6], [58, 8, 0.6]].map(([cx, cy, r], i) => /*#__PURE__*/React.createElement("circle", {
    key: i,
    cx: cx,
    cy: cy,
    r: r,
    fill: "#ffffff",
    opacity: "0.85"
  })), [[12, 12, 0.5, '#FFE08A'], [40, 22, 0.5, '#9FE0FF'], [24, 44, 0.5, '#FFB0E0'], [52, 32, 0.5, '#B0FFD0']].map(([cx, cy, r, c], i) => /*#__PURE__*/React.createElement("circle", {
    key: `c-${i}`,
    cx: cx,
    cy: cy,
    r: r,
    fill: c,
    opacity: "0.75"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v2-metacryl-shine",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: "0.40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#ffffff",
    stopOpacity: "0.04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#ffffff",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: "0.15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v2-metacryl-hotspot",
    cx: "0.30",
    cy: "0.22",
    r: "0.42"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: "0.50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#ffffff",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v2-metacryl-core",
    cx: "0.5",
    cy: "0.46",
    r: "0.40"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: "0.62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32%",
    stopColor: "#ffffff",
    stopOpacity: "0.30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#ffffff",
    stopOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: "0"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#v2-shadow)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--c-base)",
    dangerouslySetInnerHTML: {
      __html: p.baseSvg || p.innerSvg
    }
  }), p.overlaySvg && /*#__PURE__*/React.createElement("g", {
    clipPath: p.clipShapes ? `url(#${clipId})` : undefined
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--c-base)",
    dangerouslySetInnerHTML: {
      __html: p.overlaySvg
    }
  })), finish === 'galaxy' && p.clipShapes && /*#__PURE__*/React.createElement("g", {
    clipPath: `url(#${clipId})`,
    style: {
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "895",
    height: "923",
    fill: "url(#v2-galaxy-pattern)",
    opacity: "0.85"
  })), rfn(logoTop, p.slots.top, 'top'), rfn(logoCenter, p.slots.center, 'center'), rfn(logoBottom, p.slots.bottom, 'bottom')), renderInstagramText(instagram && instagram.trim() ? '@' + instagram.replace(/^@/, '') : '', p.instagramSlot, instagramFont || '"Space Grotesk", sans-serif', 600, instagramScale || 1), false && metacryl && p.clipShapes && /*#__PURE__*/React.createElement("g", {
    clipPath: `url(#${clipId})`,
    style: {
      pointerEvents: 'none'
    }
  }, p.clipShapes.map((s, i) => /*#__PURE__*/React.createElement("path", {
    key: `m-${i}`,
    d: s.d,
    transform: s.transform || undefined,
    fill: "url(#v2-metacryl-shine)"
  })), p.clipShapes.map((s, i) => /*#__PURE__*/React.createElement("path", {
    key: `mh-${i}`,
    d: s.d,
    transform: s.transform || undefined,
    fill: "url(#v2-metacryl-hotspot)"
  })), p.clipShapes.map((s, i) => /*#__PURE__*/React.createElement("path", {
    key: `mc-${i}`,
    d: s.d,
    transform: s.transform || undefined,
    fill: "url(#v2-metacryl-core)",
    style: {
      mixBlendMode: 'screen'
    }
  }))));
};
window.V2Cover = V2Cover;
// Alias para que el resto de la app pueda seguir usando <window.Cover />
window.Cover = V2Cover;

/* ===================== app.jsx ===================== */
// App principal del configurador

const {
  useState,
  useEffect,
  useMemo,
  useRef
} = React;
const COLORS = [{
  id: 'black',
  label: 'Negro',
  hex: '#0E0E10'
}, {
  id: 'white',
  label: 'Blanco',
  hex: '#F5F4F0'
}, {
  id: 'gray',
  label: 'Gris',
  hex: '#7B7E84'
}, {
  id: 'red',
  label: 'Rojo',
  hex: '#E0282E'
}, {
  id: 'pink',
  label: 'Rosa',
  hex: '#F08CB0'
}, {
  id: 'yellow',
  label: 'Amarillo',
  hex: '#F2C53D'
}, {
  id: 'gold',
  label: 'Oro',
  hex: '#C39634'
}, {
  id: 'lgreen',
  label: 'Verde claro',
  hex: '#5BB97A'
}, {
  id: 'dgreen',
  label: 'Verde oscuro',
  hex: '#1F4D34'
}, {
  id: 'turquoise',
  label: 'Turquesa',
  hex: '#23B3B0'
}, {
  id: 'dblue',
  label: 'Azul oscuro',
  hex: '#1A2E5C'
}, {
  id: 'violet',
  label: 'Violeta',
  hex: '#6A2BB0'
}];
const findColor = idOrHex => {
  if (typeof idOrHex === 'string' && idOrHex.charAt(0) === '#') {
    return {
      id: idOrHex,
      label: 'Personalizado',
      hex: idOrHex,
      custom: true
    };
  }
  return COLORS.find(c => c.id === idOrHex) || COLORS[0];
};

// Luminancia aproximada: ¿el color es claro? (para elegir tono del check)
const isLightHex = hex => {
  const h = (hex || '').replace('#', '');
  if (h.length < 6) return false;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return 0.299 * r + 0.587 * g + 0.114 * b > 150;
};
const BASE_PRICE = 28.00;
const EXTRA_LOGO_PRICE = 0.00; // los logos no tienen coste extra
const INSTAGRAM_PRICE = 0.00; // Instagram gratis
const GALAXY_PRICE = 3.50;
const METACRYL_PRICE = 4.00;
const FINISH_OPTIONS = [{
  id: 'matte',
  label: 'Mate',
  desc: 'Acabado liso, sin reflejos',
  extra: 0
}, {
  id: 'galaxy',
  label: 'Galaxy (purpurina)',
  desc: 'Efecto purpurina con destellos',
  extra: GALAXY_PRICE
}];
const METACRYL_OPTIONS = [{
  id: 'no',
  label: 'Sin metacrilato',
  desc: 'Acabado estándar',
  extra: 0
}, {
  id: 'yes',
  label: 'Con metacrilato',
  desc: 'Capa protectora transparente brillante',
  extra: METACRYL_PRICE
}];
const INSTAGRAM_FONTS = [{
  id: 'space',
  label: 'Tech',
  css: '"Space Grotesk", sans-serif'
}, {
  id: 'archivo',
  label: 'Bold',
  css: '"Archivo Black", sans-serif'
}, {
  id: 'bricolage',
  label: 'Editorial',
  css: '"Bricolage Grotesque", serif'
}, {
  id: 'nunito',
  label: 'Redonda',
  css: '"Nunito", sans-serif'
}, {
  id: 'mono',
  label: 'Mono',
  css: '"JetBrains Mono", "Courier New", monospace'
}, {
  id: 'cursive',
  label: 'Cursiva',
  css: '"Caveat", cursive'
}];
const DEFAULT_CONFIG = {
  design: 'v2',
  base: 'black',
  details: 'gold',
  letters: 'white',
  logoTop: 'sop',
  logoCenter: '2fast',
  logoBottom: 'stage6',
  instagram: 'sopessential',
  instagramFont: 'space',
  instagramScale: 1,
  finish: 'matte',
  metacryl: 'no',
  notes: ''
};
const TWEAK_DEFAULS = /*EDITMODE-BEGIN*/{
  "fontFamily": "Nunito",
  "swatchShape": "circle",
  "density": "comfortable",
  "theme": "light"
} /*EDITMODE-END*/;

// -------------------- Componentes UI --------------------

const ColorSwatch = ({
  color,
  active,
  onClick,
  shape
}) => {
  const isWhite = color.id === 'white';
  const radius = shape === 'square' ? '8px' : shape === 'pill' ? '14px' : '999px';
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClick,
    className: "swatch",
    "data-active": active,
    title: color.label,
    style: {
      background: color.hex,
      borderRadius: radius,
      boxShadow: isWhite ? 'inset 0 0 0 1px rgba(0,0,0,0.12)' : 'inset 0 0 0 1px rgba(0,0,0,0.06)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "swatch-check",
    "aria-hidden": "true",
    style: {
      color: isWhite || ['yellow', 'lgreen', 'pink', 'turquoise'].includes(color.id) ? '#0E0E10' : '#fff'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 16",
    width: "14",
    height: "14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5 L7 12 L13 4.5",
    stroke: "currentColor",
    strokeWidth: "2.2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ColorRow = ({
  label,
  hint,
  value,
  onChange,
  shape
}) => {
  const radius = shape === 'square' ? '8px' : shape === 'pill' ? '14px' : '999px';
  const isCustom = typeof value === 'string' && value.charAt(0) === '#';
  const customHex = isCustom ? value : '#ff7a00';
  return /*#__PURE__*/React.createElement("div", {
    className: "config-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "config-row-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "config-label"
  }, label), hint && /*#__PURE__*/React.createElement("span", {
    className: "config-hint"
  }, hint)), /*#__PURE__*/React.createElement("div", {
    className: "swatch-grid"
  }, COLORS.map(c => /*#__PURE__*/React.createElement(ColorSwatch, {
    key: c.id,
    color: c,
    active: value === c.id,
    onClick: () => onChange(c.id),
    shape: shape
  })), /*#__PURE__*/React.createElement("label", {
    className: "swatch swatch-custom",
    "data-active": isCustom,
    title: "Color personalizado\u2014elige cualquier tono",
    style: {
      borderRadius: radius,
      background: isCustom ? customHex : 'conic-gradient(from 90deg, #ff4d4d, #ffd24d, #5bff8f, #4dd2ff, #b04dff, #ff4db0, #ff4d4d)',
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.10)',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "color",
    value: customHex,
    onChange: e => onChange(e.target.value),
    className: "swatch-custom-input",
    "aria-label": `${label}: elegir color personalizado`
  }), isCustom ? /*#__PURE__*/React.createElement("span", {
    className: "swatch-check",
    "aria-hidden": "true",
    style: {
      opacity: 1,
      color: isLightHex(customHex) ? '#0E0E10' : '#fff'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 16",
    width: "14",
    height: "14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5 L7 12 L13 4.5",
    stroke: "currentColor",
    strokeWidth: "2.2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))) : /*#__PURE__*/React.createElement("span", {
    className: "swatch-custom-glyph",
    "aria-hidden": "true"
  }, "+"))));
};

// Mini preview del logo para el selector (color = letras actuales)
const LogoChip = ({
  entry,
  active,
  onClick,
  letterColor
}) => {
  const Render = entry.render;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClick,
    className: "logo-chip",
    "data-active": active,
    title: entry.label
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo-chip-preview"
  }, entry.id === 'none' ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "-30 -30 60 60",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("line", {
    x1: "-18",
    y1: "-18",
    x2: "18",
    y2: "18",
    stroke: "#B0B0B0",
    strokeWidth: "2.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "-18",
    y1: "18",
    x2: "18",
    y2: "-18",
    stroke: "#B0B0B0",
    strokeWidth: "2.5",
    strokeLinecap: "round"
  })) : /*#__PURE__*/React.createElement("svg", {
    viewBox: "-50 -25 100 50",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement(Render, {
    color: letterColor,
    size: 45
  })))), /*#__PURE__*/React.createElement("span", {
    className: "logo-chip-label"
  }, entry.label));
};

// Dropdown de logos: trigger con preview + popover con todas las opciones.
const LogoDropdown = ({
  label,
  value,
  onChange,
  letterColor,
  haloColor,
  catalog
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onDoc = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = e => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  const selected = catalog.find(l => l.id === value) || catalog[0];
  const isNone = selected.id === 'none';
  const RenderSel = selected.render;

  // Mini preview con halo: feMorphology → detalles, encima logo en letras.
  // Si el logo lleva offset propio, lo pasamos directamente sin filtro.
  const renderPreview = (entry, size = 44) => {
    if (entry.id === 'none') {
      return /*#__PURE__*/React.createElement("svg", {
        viewBox: "-30 -18 60 36",
        width: "100%",
        height: "100%"
      }, /*#__PURE__*/React.createElement("line", {
        x1: "-18",
        y1: "-10",
        x2: "18",
        y2: "10",
        stroke: "#B0B0B0",
        strokeWidth: "2",
        strokeLinecap: "round"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "-18",
        y1: "10",
        x2: "18",
        y2: "-10",
        stroke: "#B0B0B0",
        strokeWidth: "2",
        strokeLinecap: "round"
      }));
    }
    const Render = entry.render;
    if (entry.hasCustomOffset) {
      return /*#__PURE__*/React.createElement("svg", {
        viewBox: "-50 -22 100 44",
        width: "100%",
        height: "100%"
      }, /*#__PURE__*/React.createElement(Render, {
        color: letterColor,
        offsetColor: haloColor,
        size: size
      }));
    }
    const filterId = `mini-halo-${entry.id}`;
    return /*#__PURE__*/React.createElement("svg", {
      viewBox: "-50 -22 100 44",
      width: "100%",
      height: "100%"
    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
      id: filterId,
      x: "-25%",
      y: "-25%",
      width: "150%",
      height: "150%"
    }, /*#__PURE__*/React.createElement("feMorphology", {
      in: "SourceAlpha",
      operator: "dilate",
      radius: "1.6",
      result: "halo"
    }), /*#__PURE__*/React.createElement("feFlood", {
      floodColor: haloColor,
      result: "haloColor"
    }), /*#__PURE__*/React.createElement("feComposite", {
      in: "haloColor",
      in2: "halo",
      operator: "in",
      result: "haloFill"
    }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
      in: "haloFill"
    }), /*#__PURE__*/React.createElement("feMergeNode", {
      in: "SourceGraphic"
    })))), /*#__PURE__*/React.createElement("g", {
      filter: `url(#${filterId})`
    }, /*#__PURE__*/React.createElement(Render, {
      color: letterColor,
      size: size
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "config-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "config-row-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "config-label"
  }, label), /*#__PURE__*/React.createElement("span", {
    className: "config-hint"
  }, catalog.length, " opciones")), /*#__PURE__*/React.createElement("div", {
    className: "logo-dd",
    ref: ref
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "logo-dd-trigger",
    "data-open": open,
    onClick: () => setOpen(o => !o)
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo-dd-preview"
  }, renderPreview(selected, 40)), /*#__PURE__*/React.createElement("div", {
    className: "logo-dd-meta"
  }, /*#__PURE__*/React.createElement("span", {
    className: "logo-dd-label"
  }, selected.label), /*#__PURE__*/React.createElement("span", {
    className: "logo-dd-sub"
  }, isNone ? 'Sin logo en esta zona' : 'Toca para cambiar')), /*#__PURE__*/React.createElement("svg", {
    className: "logo-dd-chev",
    viewBox: "0 0 16 16",
    width: "14",
    height: "14",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6 L8 11 L13 6",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), open && /*#__PURE__*/React.createElement("div", {
    className: "logo-dd-menu",
    role: "listbox"
  }, catalog.map(entry => /*#__PURE__*/React.createElement("button", {
    key: entry.id,
    type: "button",
    role: "option",
    "aria-selected": entry.id === value,
    className: "logo-dd-item",
    "data-active": entry.id === value,
    onClick: () => {
      onChange(entry.id);
      setOpen(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo-dd-item-preview"
  }, renderPreview(entry, 38)), /*#__PURE__*/React.createElement("span", {
    className: "logo-dd-item-label"
  }, entry.label))))));
};

// (LogoRow se mantiene por si se necesita pero ya no se usa)

// -------------------- Option row (acabado / metacrilato) --------------------

const OptionRow = ({
  label,
  hint,
  value,
  options,
  onChange
}) => /*#__PURE__*/React.createElement("div", {
  className: "config-row"
}, /*#__PURE__*/React.createElement("div", {
  className: "config-row-head"
}, /*#__PURE__*/React.createElement("span", {
  className: "config-label"
}, label), hint && /*#__PURE__*/React.createElement("span", {
  className: "config-hint"
}, hint)), /*#__PURE__*/React.createElement("div", {
  className: "opt-grid"
}, options.map(opt => /*#__PURE__*/React.createElement("button", {
  key: opt.id,
  type: "button",
  className: "opt-card",
  "data-active": value === opt.id,
  "data-variant": opt.id,
  onClick: () => onChange(opt.id)
}, /*#__PURE__*/React.createElement("div", {
  className: "opt-card-head"
}, /*#__PURE__*/React.createElement("span", {
  className: "opt-card-label"
}, opt.label), /*#__PURE__*/React.createElement("span", {
  className: "opt-card-extra"
}, opt.extra > 0 ? `+${opt.extra.toFixed(2)} €` : 'Incluido')), /*#__PURE__*/React.createElement("span", {
  className: "opt-card-desc"
}, opt.desc), /*#__PURE__*/React.createElement("span", {
  className: "opt-card-check",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 16 16",
  width: "12",
  height: "12"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 8.5 L7 12 L13 4.5",
  stroke: "currentColor",
  strokeWidth: "2.4",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))));

// -------------------- Carrito (toast) --------------------

const CartDrawer = ({
  open,
  items,
  onClose,
  onRemove
}) => {
  const total = items.reduce((s, it) => s + it.price, 0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "drawer-backdrop",
    "data-open": open,
    onClick: onClose
  }), /*#__PURE__*/React.createElement("aside", {
    className: "drawer",
    "data-open": open,
    "aria-hidden": !open
  }, /*#__PURE__*/React.createElement("header", {
    className: "drawer-head"
  }, /*#__PURE__*/React.createElement("h3", null, "Tu carrito"), /*#__PURE__*/React.createElement("button", {
    className: "icon-btn",
    onClick: onClose,
    "aria-label": "Cerrar"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6 L18 18 M18 6 L6 18"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "drawer-body"
  }, items.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "cart-empty"
  }, /*#__PURE__*/React.createElement("p", null, "A\xFAn no has a\xF1adido ning\xFAn dise\xF1o."), /*#__PURE__*/React.createElement("span", null, "Configura tu tapa y pulsa ", /*#__PURE__*/React.createElement("strong", null, "A\xF1adir al carrito"), ".")), items.map((it, i) => /*#__PURE__*/React.createElement("article", {
    key: it.id,
    className: "cart-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cart-item-thumb",
    style: {
      background: findColor(it.config.base).hex
    }
  }, /*#__PURE__*/React.createElement(window.Cover, {
    product: getDesign(it.config.design).getProduct(),
    base: findColor(it.config.base).hex,
    details: findColor(it.config.details).hex,
    letters: findColor(it.config.letters).hex,
    logoTop: it.config.logoTop,
    logoCenter: it.config.logoCenter,
    logoBottom: it.config.logoBottom,
    instagram: it.config.instagram,
    instagramFont: (INSTAGRAM_FONTS.find(f => f.id === it.config.instagramFont) || INSTAGRAM_FONTS[0]).css,
    instagramScale: it.config.instagramScale ?? 1,
    finish: it.config.finish || 'matte',
    metacryl: it.config.metacryl === 'yes'
  })), /*#__PURE__*/React.createElement("div", {
    className: "cart-item-info"
  }, /*#__PURE__*/React.createElement("h4", null, "Tapa AM6 \xB7 dise\xF1o #", String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("p", null, "Base ", findColor(it.config.base).label.toLowerCase(), " \xB7 detalles ", findColor(it.config.details).label.toLowerCase(), " \xB7 letras ", findColor(it.config.letters).label.toLowerCase()), it.config.notes && it.config.notes.trim().length > 0 && /*#__PURE__*/React.createElement("p", {
    className: "cart-item-notes"
  }, "\u201C", it.config.notes, "\u201D"), /*#__PURE__*/React.createElement("div", {
    className: "cart-item-foot"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cart-item-price"
  }, it.price.toFixed(2), " \u20AC"), /*#__PURE__*/React.createElement("button", {
    className: "link-btn",
    onClick: () => onRemove(it.id)
  }, "Eliminar")))))), items.length > 0 && /*#__PURE__*/React.createElement("footer", {
    className: "drawer-foot"
  }, /*#__PURE__*/React.createElement("div", {
    className: "drawer-total"
  }, /*#__PURE__*/React.createElement("span", null, "Total"), /*#__PURE__*/React.createElement("strong", null, total.toFixed(2), " \u20AC")), /*#__PURE__*/React.createElement("button", {
    className: "btn-primary big"
  }, "Finalizar compra"))));
};

// -------------------- Catálogo de diseños --------------------
// Cada diseño es un SVG preprocesado (window.PRODUCT_*) con su propia silueta,
// huecos y slots de logos. Para añadir uno nuevo: registra window.PRODUCT_<id>
// y añade una entrada aquí. El primer paso del configurador deja elegir diseño.
const DESIGNS = [{
  id: 'v2',
  label: 'Clásica',
  desc: 'Disco con saliente',
  getProduct: () => window.PRODUCT_V2
}, {
  id: 'rotor1',
  label: 'Rotor V1',
  desc: 'Tapa rotor con rejillas',
  getProduct: () => window.PRODUCT_ROTOR1
}, {
  id: 'rotor4',
  label: 'Rotor V4',
  desc: 'Tapa rotor con rejillas',
  getProduct: () => window.PRODUCT_ROTOR4
}, {
  id: 'rotor5',
  label: 'Rotor V5',
  desc: 'Tapa rotor con rejillas',
  getProduct: () => window.PRODUCT_ROTOR5
}, {
  id: 'rotor6',
  label: 'Rotor V6',
  desc: 'Tapa rotor con rejillas',
  getProduct: () => window.PRODUCT_ROTOR6
}, {
  id: 'rotor62',
  label: 'Rotor V6.2',
  desc: 'Tapa rotor con rejillas',
  getProduct: () => window.PRODUCT_ROTOR62
}, {
  id: 'rotor10',
  label: 'Rotor V10',
  desc: 'Tapa rotor con rejillas',
  getProduct: () => window.PRODUCT_ROTOR10
}];
const getDesign = id => DESIGNS.find(d => d.id === id) || DESIGNS[0];

// Selector de diseño: rejilla de miniaturas (mini-render real de cada tapa).
const DesignPicker = ({
  value,
  onChange,
  base,
  details,
  letters
}) => /*#__PURE__*/React.createElement("div", {
  className: "config-row"
}, /*#__PURE__*/React.createElement("div", {
  className: "config-row-head"
}, /*#__PURE__*/React.createElement("span", {
  className: "config-label"
}, "Elige tu dise\xF1o"), /*#__PURE__*/React.createElement("span", {
  className: "config-hint"
}, "Cada dise\xF1o tiene su forma, huecos y posici\xF3n de logos")), /*#__PURE__*/React.createElement("div", {
  className: "design-grid"
}, DESIGNS.map(d => /*#__PURE__*/React.createElement("button", {
  key: d.id,
  type: "button",
  className: "design-card",
  "data-active": value === d.id,
  onClick: () => onChange(d.id),
  title: d.label
}, /*#__PURE__*/React.createElement("div", {
  className: "design-card-thumb"
}, /*#__PURE__*/React.createElement(window.Cover, {
  product: d.getProduct(),
  base: base,
  details: details,
  letters: letters,
  logoTop: "none",
  logoCenter: "none",
  logoBottom: "none",
  instagram: "",
  instagramFont: "",
  instagramScale: 1,
  finish: "matte",
  metacryl: false
})), /*#__PURE__*/React.createElement("span", {
  className: "design-card-label"
}, d.label), /*#__PURE__*/React.createElement("span", {
  className: "design-card-check",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 16 16",
  width: "13",
  height: "13"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 8.5 L7 12 L13 4.5",
  stroke: "currentColor",
  strokeWidth: "2.4",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))));

// -------------------- App --------------------

function App() {
  const [tweaks, setTweak] = window.useTweaks(TWEAK_DEFAULS);
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [justAdded, setJustAdded] = useState(false);
  const update = (key, value) => setConfig(c => ({
    ...c,
    [key]: value
  }));

  // Precio del diseño actual
  const price = useMemo(() => {
    let p = BASE_PRICE;
    if (config.logoTop !== 'none') p += EXTRA_LOGO_PRICE;
    if (config.logoCenter !== 'none') p += EXTRA_LOGO_PRICE;
    if (config.logoBottom !== 'none') p += EXTRA_LOGO_PRICE;
    if (config.instagram && config.instagram.trim().length > 0) p += INSTAGRAM_PRICE;
    p += FINISH_OPTIONS.find(o => o.id === config.finish)?.extra || 0;
    p += METACRYL_OPTIONS.find(o => o.id === config.metacryl)?.extra || 0;
    return p;
  }, [config]);
  const [buying, setBuying] = useState(false);
  const addToCart = () => {
    // En la tienda Shopify: añadimos al carrito real con imagen + propiedades.
    if (window.ShopifyCart && window.ShopifyCart.isShopify()) {
      setBuying(true);
      window.ShopifyCart.addToShopifyCart({
        config: {
          ...config
        },
        summaryLines,
        onError: msg => {
          setBuying(false);
          alert('No se pudo añadir al carrito: ' + msg);
        }
      });
      return;
    }
    // Preview (fuera de Shopify): carrito interno de demostración.
    const id = `d-${Date.now()}`;
    setCart(c => [...c, {
      id,
      config: {
        ...config
      },
      price
    }]);
    setJustAdded(true);
    setTimeout(() => setJustAdded(false), 1800);
  };

  // Aplicamos la font global vía CSS var
  useEffect(() => {
    document.documentElement.style.setProperty('--ui-font', tweaks.fontFamily);
    document.documentElement.dataset.density = tweaks.density;
    document.documentElement.dataset.theme = tweaks.theme;
  }, [tweaks.fontFamily, tweaks.density, tweaks.theme]);
  const baseHex = findColor(config.base).hex;
  const detailsHex = findColor(config.details).hex;
  const lettersHex = findColor(config.letters).hex;
  const activeProduct = getDesign(config.design).getProduct();
  const instagramFontCss = (INSTAGRAM_FONTS.find(f => f.id === config.instagramFont) || INSTAGRAM_FONTS[0]).css;

  // Resumen
  const summaryLines = [{
    label: 'Producto',
    value: 'Tapa de encendido AM6 49cc'
  }, {
    label: 'Modelo',
    value: getDesign(config.design).label
  }, {
    label: 'Color base',
    value: findColor(config.base).label,
    swatch: baseHex
  }, {
    label: 'Color detalles',
    value: findColor(config.details).label,
    swatch: detailsHex
  }, {
    label: 'Color letras',
    value: findColor(config.letters).label,
    swatch: lettersHex
  }, {
    label: 'Logo superior',
    value: window.LOGO_CATALOG.find(l => l.id === config.logoTop)?.label
  }, {
    label: 'Logo central',
    value: window.LOGO_CATALOG.find(l => l.id === config.logoCenter)?.label
  }, {
    label: 'Logo inferior',
    value: window.LOGO_CATALOG.find(l => l.id === config.logoBottom)?.label
  }, {
    label: 'Instagram',
    value: config.instagram ? `@${config.instagram.replace(/^@/, '')}` : '—'
  }, {
    label: 'Acabado',
    value: (FINISH_OPTIONS.find(o => o.id === config.finish) || FINISH_OPTIONS[0]).label + ((FINISH_OPTIONS.find(o => o.id === config.finish) || FINISH_OPTIONS[0]).extra ? ` (+${FINISH_OPTIONS.find(o => o.id === config.finish).extra.toFixed(2)} €)` : '')
  }, {
    label: 'Metacrilato',
    value: (METACRYL_OPTIONS.find(o => o.id === config.metacryl) || METACRYL_OPTIONS[0]).label + ((METACRYL_OPTIONS.find(o => o.id === config.metacryl) || METACRYL_OPTIONS[0]).extra ? ` (+${METACRYL_OPTIONS.find(o => o.id === config.metacryl).extra.toFixed(2)} €)` : '')
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, !window.IS_SHOPIFY && /*#__PURE__*/React.createElement("header", {
    className: "topbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brand"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brand-mark",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 28 28",
    width: "22",
    height: "22"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "13",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("text", {
    x: "14",
    y: "14",
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      fontFamily: '"Archivo Black", sans-serif',
      fontWeight: 900,
      fontSize: 11
    }
  }, "SE"))), /*#__PURE__*/React.createElement("div", {
    className: "brand-name"
  }, /*#__PURE__*/React.createElement("strong", null, "Sop Essential"), /*#__PURE__*/React.createElement("span", null, "Customs \xB7 made in spain"))), /*#__PURE__*/React.createElement("nav", {
    className: "topnav"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "topnav-link"
  }, "Tienda"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "topnav-link is-current"
  }, "Personalizar"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "topnav-link"
  }, "Galer\xEDa"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "topnav-link"
  }, "Contacto")), /*#__PURE__*/React.createElement("div", {
    className: "top-actions"
  }, /*#__PURE__*/React.createElement("button", {
    className: "icon-btn",
    "aria-label": tweaks.theme === 'dark' ? 'Tema claro' : 'Tema oscuro',
    onClick: () => setTweak('theme', tweaks.theme === 'dark' ? 'light' : 'dark')
  }, tweaks.theme === 'dark' ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19"
  })) : /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5A8 8 0 0 1 9.5 4 6.5 6.5 0 1 0 20 14.5Z"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "icon-btn",
    "aria-label": "Buscar"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20 L16 16"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "cart-btn",
    onClick: () => setCartOpen(true)
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6 H6 L8 17 H19 L21 9 H7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "20",
    r: "1.5"
  })), /*#__PURE__*/React.createElement("span", null, "Carrito"), cart.length > 0 && /*#__PURE__*/React.createElement("span", {
    className: "cart-badge"
  }, cart.length)))), !window.IS_SHOPIFY && /*#__PURE__*/React.createElement("div", {
    className: "crumbs"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#"
  }, "Inicio"), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true
  }, "\u203A"), /*#__PURE__*/React.createElement("a", {
    href: "#"
  }, "Tapas de encendido"), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true
  }, "\u203A"), /*#__PURE__*/React.createElement("span", {
    className: "crumbs-current"
  }, "Personalizar AM6 49cc")), /*#__PURE__*/React.createElement("main", {
    className: "layout"
  }, /*#__PURE__*/React.createElement("section", {
    className: "preview"
  }, /*#__PURE__*/React.createElement("div", {
    className: "preview-stage"
  }, /*#__PURE__*/React.createElement("div", {
    className: "preview-cover",
    "data-finish": config.finish,
    "data-metacryl": config.metacryl,
    style: (() => {
      const vb = (activeProduct.viewBox || '0 0 895 923').split(/\s+/);
      const w = parseFloat(vb[2]) || 895,
        h = parseFloat(vb[3]) || 923;
      return {
        '--cover-ar': `${w} / ${h}`
      };
    })()
  }, /*#__PURE__*/React.createElement(window.Cover, {
    product: activeProduct,
    base: baseHex,
    details: detailsHex,
    letters: lettersHex,
    logoTop: config.logoTop,
    logoCenter: config.logoCenter,
    logoBottom: config.logoBottom,
    instagram: config.instagram,
    instagramFont: instagramFontCss,
    instagramScale: config.instagramScale ?? 1,
    finish: config.finish,
    metacryl: config.metacryl === 'yes'
  })), /*#__PURE__*/React.createElement("div", {
    className: "preview-floor"
  })), /*#__PURE__*/React.createElement("div", {
    className: "preview-meta"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Tapa de encendido AM6"), /*#__PURE__*/React.createElement("p", null, "Mecanizada en aluminio \xB7 pintura epoxi \xB7 compatible con motores Minarelli AM6 de 49cc.")), /*#__PURE__*/React.createElement("div", {
    className: "preview-tags"
  }, /*#__PURE__*/React.createElement("span", {
    className: "tag"
  }, "Hecho a mano"), /*#__PURE__*/React.createElement("span", {
    className: "tag"
  }, "Env\xEDo 3\u20135 d\xEDas"), /*#__PURE__*/React.createElement("span", {
    className: "tag"
  }, "Dise\xF1o \xFAnico")))), /*#__PURE__*/React.createElement("section", {
    className: "panel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "step"
  }, "Personaliza tu tapa"), /*#__PURE__*/React.createElement("h2", null, "Configurador en directo"), /*#__PURE__*/React.createElement("p", null, "Los cambios se reflejan al instante en la previsualizaci\xF3n.")), /*#__PURE__*/React.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/React.createElement(DesignPicker, {
    value: config.design,
    onChange: v => update('design', v),
    base: baseHex,
    details: detailsHex,
    letters: lettersHex
  }), /*#__PURE__*/React.createElement("div", {
    className: "divider"
  }), activeProduct.slots && activeProduct.slots.top && /*#__PURE__*/React.createElement(LogoDropdown, {
    label: "Logo superior",
    value: config.logoTop,
    onChange: v => update('logoTop', v),
    letterColor: lettersHex,
    haloColor: detailsHex,
    catalog: window.LOGO_CATALOG
  }), activeProduct.slots && activeProduct.slots.center && /*#__PURE__*/React.createElement(LogoDropdown, {
    label: "Logo central",
    value: config.logoCenter,
    onChange: v => update('logoCenter', v),
    letterColor: lettersHex,
    haloColor: detailsHex,
    catalog: window.LOGO_CATALOG
  }), activeProduct.slots && activeProduct.slots.bottom && /*#__PURE__*/React.createElement(LogoDropdown, {
    label: "Logo inferior",
    value: config.logoBottom,
    onChange: v => update('logoBottom', v),
    letterColor: lettersHex,
    haloColor: detailsHex,
    catalog: window.LOGO_CATALOG
  }), /*#__PURE__*/React.createElement("div", {
    className: "config-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "config-row-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "config-label"
  }, "Instagram"), /*#__PURE__*/React.createElement("span", {
    className: "config-hint"
  }, "Aparecer\xE1 grabado con @")), /*#__PURE__*/React.createElement("div", {
    className: "input-wrap"
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-prefix"
  }, "@"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "input",
    value: config.instagram,
    onChange: e => update('instagram', e.target.value.replace(/^@/, '').replace(/\s+/g, '')),
    placeholder: "tu_usuario",
    maxLength: 22
  }), /*#__PURE__*/React.createElement("span", {
    className: "input-counter"
  }, config.instagram.length, "/22")), /*#__PURE__*/React.createElement("div", {
    className: "font-chips"
  }, INSTAGRAM_FONTS.map(f => /*#__PURE__*/React.createElement("button", {
    key: f.id,
    type: "button",
    className: "font-chip",
    "data-active": config.instagramFont === f.id,
    onClick: () => update('instagramFont', f.id),
    style: {
      fontFamily: f.css
    },
    title: f.label
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-chip-sample"
  }, "@", config.instagram || 'tu_user'), /*#__PURE__*/React.createElement("span", {
    className: "font-chip-label"
  }, f.label)))), /*#__PURE__*/React.createElement("div", {
    className: "insta-size"
  }, /*#__PURE__*/React.createElement("div", {
    className: "insta-size-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "config-hint"
  }, "Tama\xF1o del texto"), /*#__PURE__*/React.createElement("span", {
    className: "insta-size-val"
  }, Math.round((config.instagramScale ?? 1) * 100), "%")), /*#__PURE__*/React.createElement("div", {
    className: "insta-size-controls"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "size-btn",
    "aria-label": "Reducir tama\xF1o",
    onClick: () => update('instagramScale', Math.max(0.6, Math.round(((config.instagramScale ?? 1) - 0.1) * 10) / 10))
  }, "\u2212"), /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "size-range",
    min: "0.6",
    max: "1.6",
    step: "0.05",
    value: config.instagramScale ?? 1,
    onChange: e => update('instagramScale', parseFloat(e.target.value))
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "size-btn",
    "aria-label": "Aumentar tama\xF1o",
    onClick: () => update('instagramScale', Math.min(1.6, Math.round(((config.instagramScale ?? 1) + 0.1) * 10) / 10))
  }, "+")))), /*#__PURE__*/React.createElement("div", {
    className: "divider"
  }), /*#__PURE__*/React.createElement(ColorRow, {
    label: "Color base",
    hint: "Fondo de la tapa (debajo de detalles y logos)",
    value: config.base,
    onChange: v => update('base', v),
    shape: tweaks.swatchShape
  }), /*#__PURE__*/React.createElement(ColorRow, {
    label: "Color detalles",
    hint: "Aro/paredes, nervaduras, tornillos y offset de logos",
    value: config.details,
    onChange: v => update('details', v),
    shape: tweaks.swatchShape
  }), /*#__PURE__*/React.createElement(ColorRow, {
    label: "Color letras",
    hint: "Relleno de los logos y texto de Instagram",
    value: config.letters,
    onChange: v => update('letters', v),
    shape: tweaks.swatchShape
  }), /*#__PURE__*/React.createElement("div", {
    className: "divider"
  }), /*#__PURE__*/React.createElement(OptionRow, {
    label: "Acabado de la tapa",
    hint: "Mate o efecto purpurina",
    value: config.finish,
    options: FINISH_OPTIONS,
    onChange: v => update('finish', v)
  }), /*#__PURE__*/React.createElement(OptionRow, {
    label: "Capa de metacrilato",
    hint: "Protege la pintura y le da brillo extra",
    value: config.metacryl,
    options: METACRYL_OPTIONS,
    onChange: v => update('metacryl', v)
  })), /*#__PURE__*/React.createElement("div", {
    className: "summary"
  }, /*#__PURE__*/React.createElement("h3", null, "Resumen de tu dise\xF1o"), /*#__PURE__*/React.createElement("ul", null, summaryLines.map((s, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "summary-label"
  }, s.label), /*#__PURE__*/React.createElement("span", {
    className: "summary-value"
  }, s.swatch && /*#__PURE__*/React.createElement("span", {
    className: "summary-swatch",
    style: {
      background: s.swatch
    }
  }), s.value || '—')))), /*#__PURE__*/React.createElement("div", {
    className: "notes-block"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "notes",
    className: "notes-label"
  }, /*#__PURE__*/React.createElement("span", null, "Comentarios extras"), /*#__PURE__*/React.createElement("span", {
    className: "notes-hint"
  }, "Opcional \xB7 cualquier detalle que quieras que tengamos en cuenta")), /*#__PURE__*/React.createElement("textarea", {
    id: "notes",
    className: "notes-area",
    value: config.notes,
    onChange: e => update('notes', e.target.value.slice(0, 400)),
    rows: 4,
    placeholder: "Ej: el offset un poco m\xE1s grueso, prefiero el dorado m\xE1s c\xE1lido, env\xEDo urgente, etc."
  }), /*#__PURE__*/React.createElement("div", {
    className: "notes-foot"
  }, /*#__PURE__*/React.createElement("span", null, config.notes.length, "/400"))), /*#__PURE__*/React.createElement("div", {
    className: "price-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-stack"
  }, /*#__PURE__*/React.createElement("span", {
    className: "price-label"
  }, "Precio total"), /*#__PURE__*/React.createElement("span", {
    className: "price-value"
  }, price.toFixed(2), " \u20AC")), /*#__PURE__*/React.createElement("button", {
    className: "btn-primary",
    onClick: addToCart,
    "data-added": justAdded,
    disabled: buying
  }, buying ? /*#__PURE__*/React.createElement(React.Fragment, null, "A\xF1adiendo\u2026") : justAdded ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "18",
    height: "18",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12 L10 17 L20 7"
  })), "A\xF1adido") : /*#__PURE__*/React.createElement(React.Fragment, null, "A\xF1adir al carrito"))), /*#__PURE__*/React.createElement("p", {
    className: "summary-foot"
  }, "Tras a\xF1adirla, puedes seguir modificando para crear otro dise\xF1o y a\xF1adirlo tambi\xE9n.")))), /*#__PURE__*/React.createElement(CartDrawer, {
    open: cartOpen,
    items: cart,
    onClose: () => setCartOpen(false),
    onRemove: id => setCart(c => c.filter(it => it.id !== id))
  }), /*#__PURE__*/React.createElement(window.TweaksPanel, null, /*#__PURE__*/React.createElement(window.TweakSection, {
    title: "Tipograf\xEDa"
  }, /*#__PURE__*/React.createElement(window.TweakSelect, {
    label: "Familia",
    value: tweaks.fontFamily,
    onChange: v => setTweak('fontFamily', v),
    options: [{
      value: 'Nunito',
      label: 'Nunito (redondeada)'
    }, {
      value: 'Quicksand',
      label: 'Quicksand (suave)'
    }, {
      value: 'DM Sans',
      label: 'DM Sans (neutra)'
    }, {
      value: 'Space Grotesk',
      label: 'Space Grotesk (tech)'
    }, {
      value: 'Bricolage Grotesque',
      label: 'Bricolage (editorial)'
    }]
  })), /*#__PURE__*/React.createElement(window.TweakSection, {
    title: "Estilo de la UI"
  }, /*#__PURE__*/React.createElement(window.TweakRadio, {
    label: "Forma swatches",
    value: tweaks.swatchShape,
    onChange: v => setTweak('swatchShape', v),
    options: [{
      value: 'circle',
      label: '● Círculo'
    }, {
      value: 'square',
      label: '■ Cuadro'
    }, {
      value: 'pill',
      label: '▢ Pill'
    }]
  }), /*#__PURE__*/React.createElement(window.TweakRadio, {
    label: "Densidad",
    value: tweaks.density,
    onChange: v => setTweak('density', v),
    options: [{
      value: 'comfortable',
      label: 'Cómoda'
    }, {
      value: 'compact',
      label: 'Compacta'
    }]
  }), /*#__PURE__*/React.createElement(window.TweakRadio, {
    label: "Tema",
    value: tweaks.theme,
    onChange: v => setTweak('theme', v),
    options: [{
      value: 'light',
      label: 'Claro'
    }, {
      value: 'dark',
      label: 'Oscuro'
    }]
  }))));
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(/*#__PURE__*/React.createElement(App, null));
